import React from 'react';
import { createRoot } from 'react-dom/client'; // 1. Αλλαγή στο import
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

// 2. Βρίσκουμε το root element
const container = document.getElementById('root');

// 3. Δημιουργούμε το root με τη νέα μέθοδο
const root = createRoot(container);

// 4. Κάνουμε render
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();


